// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__7dg+8","logo":"MainNavigation_logo__PgxC7","active":"MainNavigation_active__W8l+j","badge":"MainNavigation_badge__bzGrJ"};